import API from "../API";
import { getGuestTokenParams, withGuestTokenPayload } from "../../token/token";

export const CreateOrderRazApi = async (payload) => {
  try {
    const response = await API.post(`/ecommerce/addon/products`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const PlaceOrderApi = async (payload) => {
  try {
    const response = await API.post(
      `/ecommerce/orders`,
      withGuestTokenPayload(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelOrderApi = async (payload) => {
  try {
    const response = await API.put(
      `/ecommerce/orders/cancel?orderItemIds=${payload?.orderItemIds || []}&orderId=${payload?.orderId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const returnOrderApi = async (payload) => {
  try {
    const response = await API.put(
      `/ecommerce/request/rto?orderId=${payload?.orderId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrdersApi = async (payload) => {
  try {
    const response = await API.get(`/ecommerce/orders`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSingleOrdersApi = async (payload) => {
  try {
    const response = await API.get(
      `/ecommerce/orders/${payload?.orderId || null}`,
      { params: getGuestTokenParams() },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const requestCancelOrdersApi = async (payload) => {
  try {
    const response = await API.put(
      `/request/${payload?.actionId || ""}/cancel`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const returnOrdersApi = async (payload) => {
  try {
    const response = await API.put(
      `/request/${payload?.orderItemId || ""}/return`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadCustomPhotoApi = async (payload) => {
  try {
    const response = await API.post(
      `/ecommerce/custom/photo/upload?orderItemId=${payload?.orderItemId || ""}`,
      payload,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadOrderCustomPhotoApi = async (payload) => {
  try {
    const { orderItemId, cartCustomizationItem = [] } = payload || {};

    const response = await API.post(
      `/ecommerce/custom/photo/upload?orderItemId=${orderItemId || ""}`,
      { cartCustomizationItem },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
